export const extendedCRUDMethods = {
    delete: { method: 'DELETE', params: { id: '@_id' } },
    update: { method: 'PATCH', params: { id: '@_id' } }
};


// WEBPACK FOOTER //
// ./client/components/resources/extendedCRUDMethods.ts